// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3cORF","notes":"Notes_notes__ldTBT"};